import React from 'react';
import { X, FileText } from 'lucide-react';

export default function NormsModal({ open, onClose, title, norms }) {
  if (!open || !norms) return null;

  return (
    <div
      className="fixed inset-0 bg-black/85 z-[200] flex flex-col"
      onClick={onClose}
    >
      {/* Header */}
      <div
        className="flex items-center justify-between px-4 py-3 bg-[#48293A] flex-shrink-0"
        onClick={e => e.stopPropagation()}
      >
        <h3 className="text-white font-bold text-base leading-tight">
          {title} <span className="text-white/60 font-normal">· Normas de uso</span>
        </h3>
        <button
          onClick={onClose}
          className="p-2 rounded-full bg-white/15 text-white hover:bg-white/25 ml-3 flex-shrink-0"
          aria-label="Cerrar"
        >
          <X size={20} />
        </button>
      </div>

      {/* Cartel image — scrollable */}
      <div
        className="flex-1 overflow-y-auto"
        onClick={e => e.stopPropagation()}
      >
        {norms.cartel ? (
          <img
            src={norms.cartel}
            alt={`Normas de uso — ${title}`}
            className="w-full max-w-lg mx-auto block"
          />
        ) : (
          <div className="flex items-center justify-center h-full min-h-[300px]">
            <p className="text-white/50 text-center text-sm px-8">
              Cartel de normas no disponible.<br />
              Consulta al monitor de la actividad.
            </p>
          </div>
        )}
      </div>

      {/* Footer with PDF link */}
      {norms.cartelPdf && (
        <div
          className="px-4 py-3 bg-[#48293A]/80 backdrop-blur-sm text-center flex-shrink-0"
          onClick={e => e.stopPropagation()}
        >
          <a
            href={norms.cartelPdf}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white/70 text-sm hover:text-white transition-colors"
          >
            <FileText size={14} />
            Ver PDF en alta resolución
          </a>
        </div>
      )}
    </div>
  );
}
